type Props = { width?: number; height?: number };

export function CoprocessorLogo({ width = 40, height = 40 }: Props) {
  return (
    <img
      src="/coprocessor-icon.png"
      width={width}
      height={height}
      alt="Coprocessor"
      style={{ display: "block" }}
    />
  );
}
